import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
// import wx from './jweixin140'
import superagent from 'superagent'

Vue.config.productionTip = false

// // register wx js sdk
// var stamp = String(Date.now())
// var url = `https://ina.studiossolution.com/wx`
// superagent.get('https://funtions/get_wx_signature')

// wx.config({
//   debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
//   appId: 'wx6b2eac4a440ddd87', // 必填，公众号的唯一标识
//   timestamp: '', // 必填，生成签名的时间戳
//   nonceStr: '', // 必填，生成签名的随机串
//   signature: '',// 必填，签名
//   jsApiList: [] // 必填，需要使用的JS接口列表
// });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
